import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-gray-100 bg-white/80 backdrop-blur-md" data-id="element-1">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="flex items-center gap-2" data-id="element-3">
          {/* Logo Recreation */}
          <div className="flex items-center gap-1" data-id="element-4">
            <span className="text-2xl font-black tracking-tighter text-gray-900 font-serif" data-id="element-5">
              PiF
            </span>
            <div className="h-2 w-2 rounded-full bg-[#2D9596] mb-3" data-id="element-6"></div>
          </div>
          <div className="hidden md:flex ml-8 gap-6" data-id="element-7">
            <a href="#" className="text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-8">
              Crypto Reports
            </a>
            <a href="#" className="text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-9">
              Stock Reports
            </a>
            <a href="#" className="text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-10">
              Pricing
            </a>
            <a href="#" className="text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-11">
              Managed Portfolios ↗
            </a>
          </div>
        </div>

        <div className="flex items-center gap-4" data-id="element-12">
          <div className="hidden md:flex items-center gap-4" data-id="element-13">
            <Button variant="primary" size="sm" data-id="element-14">
              Get started
            </Button>
            <Button variant="outline" size="sm" className="rounded-full" data-id="element-15">
              Log in
            </Button>
          </div>

          <button className="md:hidden p-2 text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-16">
            {isMenuOpen ? <X data-id="element-17" /> : <Menu data-id="element-18" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden border-t border-gray-100 bg-white px-4 py-6 space-y-4" data-id="element-19">
          <a href="#" className="block text-base font-medium text-gray-900" data-id="element-20">
            Crypto Reports
          </a>
          <a href="#" className="block text-base font-medium text-gray-900" data-id="element-21">
            Stock Reports
          </a>
          <a href="#" className="block text-base font-medium text-gray-900" data-id="element-22">
            Pricing
          </a>
          <a href="#" className="block text-base font-medium text-gray-900" data-id="element-23">
            Managed Portfolios
          </a>
          <div className="pt-4 flex flex-col gap-3" data-id="element-24">
            <Button className="w-full" data-id="element-25">Get started</Button>
            <Button variant="outline" className="w-full" data-id="element-26">
              Log in
            </Button>
          </div>
        </div>}
    </header>;
}